import React from 'react';
import WorkTimeCalculator from './components/WorkTimeCalculator';
import './App.css';

function App() {
  return (
    <div className="App">
      <WorkTimeCalculator />
    </div>
  );
}

export default App;

